import { useEffect, useRef } from 'react';

// Atualização automática dos painéis internos (Comando, painel da equipe, Desk).
// Só busca dados enquanto a aba está na tela: aba escondida ou minimizada não consulta o servidor.
// Quando a pessoa volta para a aba, atualiza na hora (se a última busca tiver mais de 15 s).
export const usePolling = (fn, every = 60000, enabled = true) => {
  const fnRef = useRef(fn);
  fnRef.current = fn;
  useEffect(() => {
    if (!enabled) return undefined;
    let last = 0;
    const run = () => { last = Date.now(); fnRef.current(); };
    const visible = () => typeof document === 'undefined' || document.visibilityState !== 'hidden';
    run();
    const t = setInterval(() => { if (visible()) run(); }, every);
    const onShow = () => { if (visible() && Date.now() - last > 15000) run(); };
    document.addEventListener('visibilitychange', onShow);
    window.addEventListener('focus', onShow);
    return () => { clearInterval(t); document.removeEventListener('visibilitychange', onShow); window.removeEventListener('focus', onShow); };
  }, [every, enabled]);
};
